import { useState } from "react";
import Button from "../button";

const CareerForm = ({ setShowModal }) => {
  
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    selectedService: "",
    message: "",
  });

  const onChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    console.log(form);
    return;
  };

  return (
    <>
      <form className="w-full" onSubmit={onSubmit}>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="first-name"
            >
              First Name*
            </label>

            <input
              onChange={onChangeValue}
              className="focus:shadow-inputshadow mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-all duration-300 focus:border-visOrange"
              id="first-name"
              type="text"
              placeholder="Your first name"
              name="firstName"
              required
            />
          </div>
          <div className="w-full px-3 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="last-name"
            >
              Last Name*
            </label>
            <input
              onChange={onChangeValue}
              className="focus:shadow-inputshadow mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange"
              id="last-name"
              type="text"
              placeholder="Your last name"
              name="lastName"
            />
          </div>
        </div>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="email"
            >
              Email address*
            </label>
            <input
              onChange={onChangeValue}
              className="focus:shadow-inputshadow mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange"
              id="email"
              type="text"
              placeholder="Enter your email"
              name="email"
            />
          </div>
          <div className="w-full px-3 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="services"
            >
              Phone Number*
            </label>
            <input
              onChange={onChangeValue}
              className="focus:shadow-inputshadow mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange"
              id="services"
              type="text"
              placeholder="eg. 00000000000"
              name="selectedService"
            />
          </div>
        </div>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="message"
            >
              Upload CV*
            </label>
            <input
              onChange={onChangeValue}
              className="focus:shadow-inputshadow mb-3 block w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange"
              id="message"
              type="file"
              name="message"
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-5">
          <Button>
            <span className="px-6">Apply Now</span>
          </Button>
        </div>
      </form>
    </>
  );
};

export default CareerForm;
